<div class="container">

  <h2 class="content-heading">
    Vestment Colors
  </h2>

  <div class="table-responsive table yearDataTable" xclass="table table-striped table-vcenter table-sm" *ngIf="isLoading == false">

      <div class="xrow header gridRow row">
        <div class="col-md-3">Name</div>
        <div class="col-md-2">Abbr</div>
        <div class="col-md-2">Code</div>
        <div class="col-md-1">HTML Code</div>
        <div class="col-md-3">Description</div>
        <div class="col-md-1"></div>
      </div>

      <div id="scrollableTable">

        <div *ngFor="let obj of data" class="dateRow gridRow row">

          <div class="col-md-3">{{obj.Localized[0].Name}}</div>
          <div class="col-md-2">{{obj.Localized[0].AbbreviatedName}}</div>
          <div class="col-md-2">{{obj.Localized[0].Code}}</div>
          <div class="col-md-1">{{obj.ColorCode}}</div>
          <div class="col-md-3">{{obj.Localized[0].Description}}</div>
          <div class="col-md-1">
            <div class="btn-group">
              <button type="button" class="btn btn-sm btn-secondary js-tooltip-enabled" data-toggle="tooltip" title="" data-original-title="Edit" (click)="edit(obj)">
                  <i class="fa fa-pencil"></i>
              </button>
            </div>
          </div>
        </div>

      </div>

    </div>

  <app-progress-bar *ngIf="isLoading==true"></app-progress-bar>

</div>




